module.exports = __webpack_public_path__ + "img/Hebei-power.5e0783c7.png";